import { gate } from 'hub-http/gates';
import { useHasGate } from '../../userInfo/hooks/useHasGate';
export const useHasViewSharingRedesign = () => {
  const {
    loading,
    data: hasViewSharingRedesign
  } = useHasGate(gate('CRM:Datasets:ViewSharingRedesign'));
  if (loading) {
    return false;
  }
  return hasViewSharingRedesign;
};